<div
  id="carouselExampleFade"
  class="carousel slide carousel-fade"
  [class.half-data]="!fullImage"
  data-ride="carousel"
  *ngIf="carouselItems && carouselItems.length > 0"
>
  <ol class="carousel-indicators" *ngIf="needIndicators">
    <li
      *ngFor="let item of carouselItems; let i = index"
      [class.active]="i === selectedImgIndex"
      (click)="jumpTo(i)"
    ></li>
  </ol>
  <div class="carousel-inner full-img" *ngIf="fullImage">
    <div
      class="carousel-item"
      *ngFor="let img of picArray; let i = index"
      [class.active]="i === selectedImgIndex"
      [style.background-image]="img"
    >
      <div
        class="carousel-title-text"
        [class.text-right]="carouselItems[i].textside === 'right'"
        [class.text-left]="carouselItems[i].textside === 'left'"
        [class.text-center]="carouselItems[i].textside === 'center'"
      >
        <p class="my-0">{{ carouselItems[i].text }}</p>
      </div>
    </div>
  </div>
  <div class="carousel-inner half-image" *ngIf="!fullImage">
    <ng-container *ngFor="let img of picArray; let i = index">
      <div class="carousel-item" [class.active]="i === selectedImgIndex">
        <div class="row">
          <div class="col-lg-6" [style.background-image]="img"></div>
          <div class="col-lg-6 text-side">
            <p class="my-0 title">{{ carouselItems[i].text }}</p>
            <p class="my-0 description">
              {{ carouselItems[i].description }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="link"
        *ngIf="carouselItems[i].route && i === selectedImgIndex"
      >
        <a routerLink="/{{ carouselItems[i].route }}">
          Tovább <i class="gallery-btn fas fa-arrow-right"></i>
        </a>
      </div>
    </ng-container>
  </div>
  <a
    class="carousel-control-prev my-auto"
    *ngIf="needButtons"
    (click)="prev()"
    role="button"
    data-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a
    class="carousel-control-next my-auto"
    *ngIf="needButtons"
    (click)="next()"
    role="button"
    data-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
